<template lang="pug">
  div(class="block")
    div(class="graph", :data-close="!show", :style="graphStyle")
    div(
      class="counter",
      :data-decoration="count === 10000",
      v-if="counter > 0",
      :active="completed",
    )
      span {{counter.toLocaleString()}}
      div(v-if="count === 10000", class="decoration", :active="completed")
        decoration-svg
</template>
<script>
  import DecorationSvg from 'images/Event/Infographics/10000.svg';
  import EventListener from 'modules/mixins/eventListener';

  export default {
    components: {
      DecorationSvg,
    },
    mixins: [EventListener],
    props: {
      count: { type: Number, default: 1201 },
      width: { type: Number, default: 100 }, // %
      dn: { type: Number, default: 43 }, // カウントアップ数 素数で
    },
    data() {
      return {
        show: false,
        time: 1000,
        counter: 0,
        completed: false,
      };
    },
    computed: {
      graphStyle() {
        return {
          flexBasis: `${this.show ? (this.width * 0.4) : 0}%`,
        };
      },
      ms() {
        return this.time / (this.count / this.dn);
      },
    },
    mounted() {
      this.$listen(window, 'scroll', this.eventHandler);
    },
    methods: {
      eventHandler() {
        const { innerHeight } = window;
        const { top } = this.$el.getBoundingClientRect();
        if (innerHeight > top - 50) {
          this.countUp();
          window.removeEventListener('scroll', this.eventHandler);
        }
      },
      countUp() {
        this.show = true;
        if (this.counter < this.count) {
          if (this.count - this.counter < this.dn) {
            this.counter = this.count;
            this.completed = true;
          } else {
            this.counter += this.dn;
          }
          setTimeout(() => this.countUp(this.ms), this.ms);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .block {
    display: flex;
    align-items: center;
    width: 100%;
    height: 54px;
    @include mq('sm') {
      height: 70px;
    }
  }
  .graph {
    flex: 0 1 10%;
    width: 20px;
    height: 20px;
    background-color: $c-pink-dark;
    transition: flex-basis 1s;
    @include mq('sm') {
      height: 30px;
    }
  }
  .counter {
    position: relative;
    flex: 0 0 auto;
    color: $c-pink-dark;
    font-size: 2rem;
    font-family: 'Bebas Neue';
    letter-spacing: 1px;
    margin-left: 0.5em;
    span {
      position: relative;
      z-index: 1;
    }
    transition: font-size 0.3s;
    @include mq('sm') {
      font-size: 2.5rem;
    }
    &[data-decoration] {
      padding-left: 17px;
      @include mq('sm') {
        padding-left: 10px;
      }
      @include mq {
        padding-left: 30px;
      }
      &[active] {
        font-size: 3rem;
        @include mq('sm') {
          font-size: 3.6rem;
        }
        @include mq {
          font-size: 4.5rem;
        }
      }
    }
  }
  .decoration {
    position: absolute;
    left: -7px;
    bottom: -6px;
    transform: scale(0);
    opacity: 0;
    transition: transform 0.3s, opacity 0.3s;
    &[active] {
      transform: scale(1);
      opacity: 1;
    }
    svg {
      width: 120px;
      height: 61.98px;
      @include mq('sm') {
        width: 134px;
        height: 69.48px;
      }
      @include mq {
        width: 180px;
        height: 93.33px;
      }
    }
    @include mq('sm') {
      left: -13px;
      bottom: -7px;
    }
    @include mq {
      left: -10px;
      bottom: -9px;
    }
  }
</style>
